import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

function MiddleSection() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              Software <span className="purple">Engineering</span> & Architecture
            </h1>
            <p className="home-about-body">
              Technology leader with 8+ years of experience building scalable solutions
              and driving technical innovation.
              <br />
              <br />
              As a <b className="purple">Senior Tech Consultant</b>, I specialize in:
              <br />
              <i>
                <b className="purple">• Solution Architecture</b>
              </i>
              <br />
              <i>
                <b className="purple">• Full Stack Development</b>
              </i>
              <br />
              <i>
                <b className="purple">• Cloud & DevOps</b>
              </i>
              <br />
              <i>
                <b className="purple">• AI Implementation</b>
              </i>
              <br />
              <br />
              My open-source contributions include <b className="purple">Astroluma</b> (700+ stars) and
              <i>
                <b className="purple"> Apex Home Dashboard</b>
              </i>
              , which are helping thousands of users simplify their digital lives.
              <br />
              <br />
              I work with modern technologies like <b className="purple">Node.js</b>,{" "}
              <b className="purple">React</b>, and <b className="purple">Cloud Platforms</b> to
              create impactful solutions.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>

        <Row style={{ marginTop: "50px" }}>
          <Col md={12} className="home-about-description">
            <h1 style={{ fontSize: "2.6em", marginBottom: "30px" }}>
              My <span className="purple">Philosophy</span>
            </h1>
            <div className="approach-grid">
              <div className="approach-item">
                <h3><span className="purple">Vision</span></h3>
                <p>Building innovative solutions that transform businesses and enhance user experiences</p>
              </div>
              <div className="approach-item">
                <h3><span className="purple">Excellence</span></h3>
                <p>Delivering high-quality, scalable, and maintainable applications using best practices</p>
              </div>
              <div className="approach-item">
                <h3><span className="purple">Innovation</span></h3>
                <p>Staying ahead with emerging technologies and implementing cutting-edge solutions</p>
              </div>
              <div className="approach-item">
                <h3><span className="purple">Collaboration</span></h3>
                <p>Fostering team growth through knowledge sharing and open communication</p>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>LET'S CONNECT</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li>
                <a
                  href="https://github.com/Sanjeet990"
                  target="_blank"
                  rel="noreferrer"
                  className="home-social-icons"
                  aria-label="GitHub Profile"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li>
                <a
                  href="https://www.linkedin.com/in/sanjeet-pathak/"
                  target="_blank"
                  rel="noreferrer"
                  className="home-social-icons"
                  aria-label="LinkedIn Profile"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li>
                <a
                  href="https://www.reddit.com/r/Astroluma/"
                  target="_blank"
                  rel="noreferrer"
                  className="home-social-icons"
                  aria-label="Reddit Community"
                >
                  <i className="fab fa-reddit"></i>
                </a>
              </li>
              <li>
                <a
                  href="mailto:hello@sanjeetpathak.com"
                  className="home-social-icons"
                  aria-label="Send Email"
                >
                  <MdEmail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default MiddleSection;
